"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, ko*/
(function () {
  ko.components.register('kobo-accordion', {
    viewModel: function viewModel(params) {
      return new AccordionViewModel(params);
    },
    template: Kobo.$('#kobo-accordion-template').html()
  });
})();

var AccordionViewModel = /*#__PURE__*/function () {
  function AccordionViewModel(params) {
    _classCallCheck(this, AccordionViewModel);

    var name = params.name,
        items = params.items,
        onItemSelected = params.onItemSelected;
    this.name = name;
    this.items = ko.observableArray(items.map(function (item) {
      return new AccordionItemViewModel(item);
    }));
    this.currentItem = ko.observable();
    this.currentItem.subscribe(onItemSelected); // initialize current item

    var firstItem = this.items()[0];
    firstItem.selected(true);
    this.currentItem(firstItem);
  }

  _createClass(AccordionViewModel, [{
    key: "handleItemSelection",
    value: function handleItemSelection(item) {
      if (item.selected()) {
        return;
      }

      this.currentItem().selected(false);
      item.selected(true);
      this.currentItem(item);
    }
  }, {
    key: "handleChangeInFocus",
    value: function handleChangeInFocus(_, event) {
      var _keyCodeToActionMap;

      if (!Kobo.$(event.target).hasClass('accordion-item-selector')) {
        return true;
      }

      var keyCodeToActionMap = (_keyCodeToActionMap = {}, _defineProperty(_keyCodeToActionMap, Kobo.KeyCodes.UP, this.shiftFocusToPreviousItem.bind(this)), _defineProperty(_keyCodeToActionMap, Kobo.KeyCodes.DOWN, this.shiftFocusToNextItem.bind(this)), _defineProperty(_keyCodeToActionMap, Kobo.KeyCodes.HOME, this.shiftFocusToFirstItem.bind(this)), _defineProperty(_keyCodeToActionMap, Kobo.KeyCodes.END, this.shiftFocusToLastItem.bind(this)), _keyCodeToActionMap);
      var keyCode = event.keyCode;

      if (keyCodeToActionMap[keyCode]) {
        keyCodeToActionMap[keyCode](event.target);
        return false; // prevent scrolling
      }

      return true;
    }
  }, {
    key: "shiftFocusToPreviousItem",
    value: function shiftFocusToPreviousItem(focusedElement) {
      var focusableAccordionItemElements = Kobo.$("#".concat(this.name, "-accordion .accordion-item-selector"));
      var currentIndex = focusableAccordionItemElements.index(focusedElement);
      var previousIndex = currentIndex === 0 ? focusableAccordionItemElements.length - 1 : currentIndex - 1;
      focusableAccordionItemElements[previousIndex].focus();
    }
  }, {
    key: "shiftFocusToNextItem",
    value: function shiftFocusToNextItem(focusedElement) {
      var focusableAccordionItemElements = Kobo.$("#".concat(this.name, "-accordion .accordion-item-selector"));
      var currentIndex = focusableAccordionItemElements.index(focusedElement);
      var nextIndex = currentIndex === focusableAccordionItemElements.length - 1 ? 0 : currentIndex + 1;
      focusableAccordionItemElements[nextIndex].focus();
    }
  }, {
    key: "shiftFocusToFirstItem",
    value: function shiftFocusToFirstItem() {
      Kobo.$("#".concat(this.name, "-accordion .accordion-item-selector"))[0].focus();
    }
  }, {
    key: "shiftFocusToLastItem",
    value: function shiftFocusToLastItem() {
      Kobo.$("#".concat(this.name, "-accordion .accordion-item-selector")).slice(-1)[0].focus();
    }
  }]);

  return AccordionViewModel;
}();

var AccordionItemViewModel = function AccordionItemViewModel(item) {
  var _this = this;

  _classCallCheck(this, AccordionItemViewModel);

  var label = item.label,
      icons = item.icons,
      template = item.template;
  this.selected = ko.observable(false);
  this.label = label;
  this.icons = icons;
  this.content = {
    template: template,
    viewModel: item
  };
  this.showContent = ko.pureComputed(function () {
    return _this.selected() && _this.content.template;
  });
};

Kobo.Utilities.assignToNamespace('Kobo.Controls.Accordion.AccordionViewModel', AccordionViewModel);